// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__EwjGr","Hero":"Home_Hero__Q0iK2","Section":"Home_Section__2Eagf","Text":"Home_Text__1SJsk","Image":"Home_Image__WwDGY"};